module.exports = __webpack_public_path__ + "static/media/bg.ba33130f.jpg";